import { Grow, Modal } from "@mui/material";

const ModalShell = ({ embedded, open, children }) =>
  embedded ? (
    children
  ) : (
    <Modal open={open} onClose={null} sx={{ display: "flex", justifyContent: "center" }}>
      <Grow in={open}>{children}</Grow>
    </Modal>
  );

export default ModalShell;
